let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6UZ4f")).then(() => parcelRequire('5P2oX'));